import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c8581ee6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "financial-settlement"
};
import { message } from 'ant-design-vue';
import { OK } from '@/common';
import SearchForm from './components/SearchForm.vue';
import GpTable from './components/GpTable.vue';
import { getAccountBillList } from '@/api/billApi';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const searchFormRef = ref();
    const loading = ref(false);
    const tableData = ref([]);
    const searchParams = ref();
    const pagination = ref({
      current: 1,
      pageSize: 20,
      total: 0,
      showSizeChanger: true,
      showQuickJumper: false
    });
    const allAccountList = ref();
    const handleUpdateList = () => {
      handleSearch(false);
    };
    const handlePaginationChange = (page, pageSize) => {
      pagination.value.current = page;
      pagination.value.pageSize = pageSize;
      handleSearch(false);
    };
    const handleSortChange = (sortField, ascending) => {
      const validSortFields = ['balance', 'estimatedRevenue', 'actualInvoiceAmount', 'actualReceivedAmount', 'expectReceivedAmount', 'receivedDiff'];
      if (validSortFields.includes(sortField)) {
        if (searchParams.value) {
          searchParams.value = {
            ...searchParams.value,
            sortField: sortField,
            ascending
          };
          handleSearch(false);
        } else {
          var _searchFormRef$value;
          const formData = (_searchFormRef$value = searchFormRef.value) === null || _searchFormRef$value === void 0 ? void 0 : _searchFormRef$value.getFormData();
          searchParams.value = {
            startMonthDate: formData.startMonthDate,
            endMonthDate: formData.endMonthDate,
            accountIdList: formData.accountId,
            payChnl: formData.payChnl,
            sortField: sortField,
            ascending,
            currency: formData.currency,
            isNeedExternalSettlement: formData.isNeedExternalSettlement,
            receivedStatus: formData.receivedStatus
          };
          handleSearch(false);
        }
      }
    };
    const handleSearch = async (isReset = true) => {
      if (isReset) {
        pagination.value.current = 1;
      }
      // 如果是重置或首次搜索，需要从表单获取搜索条件
      if (isReset || !searchParams.value) {
        var _searchFormRef$value2, _searchParams$value, _searchParams$value2;
        const formData = (_searchFormRef$value2 = searchFormRef.value) === null || _searchFormRef$value2 === void 0 ? void 0 : _searchFormRef$value2.getFormData();
        // 保存现有排序参数
        const sortField = (_searchParams$value = searchParams.value) === null || _searchParams$value === void 0 ? void 0 : _searchParams$value.sortField;
        const ascending = (_searchParams$value2 = searchParams.value) === null || _searchParams$value2 === void 0 ? void 0 : _searchParams$value2.ascending;
        // 更新搜索参数
        searchParams.value = {
          startMonthDate: formData.startMonthDate,
          endMonthDate: formData.endMonthDate,
          accountIdList: formData.accountId,
          payChnl: formData.payChnl,
          isNeedExternalSettlement: formData.isNeedExternalSettlement,
          currency: formData.currency,
          receivedStatus: formData.receivedStatus
        };
        // 保留排序参数
        if (sortField && ascending !== undefined) {
          searchParams.value.sortField = sortField;
          searchParams.value.ascending = ascending;
        }
      }
      loading.value = true;
      try {
        const params = {
          ...searchParams.value,
          pageNum: pagination.value.current,
          pageSize: pagination.value.pageSize
        };
        const res = await getAccountBillList(params);
        if (res && res.code === OK) {
          tableData.value = res.data.list;
          pagination.value.total = res.data.total;
        }
      } catch (error) {
        message.error('查询失败');
      } finally {
        loading.value = false;
      }
    };
    const handleReset = () => {
      searchParams.value = undefined;
      handleSearch();
    };
    const getAllAccountList = list => {
      allAccountList.value = list;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(SearchForm, {
        ref_key: "searchFormRef",
        ref: searchFormRef,
        onSearch: handleSearch,
        onReset: handleReset,
        onSendAccount: getAllAccountList
      }, null, 512), _createVNode(GpTable, {
        loading: loading.value,
        data: tableData.value,
        pagination: pagination.value,
        "search-params": searchParams.value,
        allAccountList: allAccountList.value,
        onPaginationChange: handlePaginationChange,
        onSortChange: handleSortChange,
        onUpdateList: handleUpdateList
      }, null, 8, ["loading", "data", "pagination", "search-params", "allAccountList"])]);
    };
  }
});